<template>
  <div class="section">
    <div class="list">
      <p class="head">Payment Mode</p>
      <p class="head">Bank Server Down</p>
      <p class="head">Bank Server Timeout</p>
    </div>

    <div v-for="(types, pymt, index) in beneBanks" :key="index"
        class="list">
      <div class="head">
        <p>{{pymt}}</p>
      </div>

      <div class="content" v-for="(bank, type, bankIndex) in types" :key="bankIndex">
        <p v-if="bank.noData">-</p>
        <p v-for="(data, dataIndex) in bank.min" :key="dataIndex"
          class="bank">
          {{data.text}}
        </p>
        <u v-if="bank.aboveLimit" @click="toggleList(pymt, type)">
          {{bank.showAll ? 'Show less' : 'Show more'}}
        </u>
      </div>
    </div>

    <table-loader v-if="!Object.keys(beneBanks).length" :css="{'border-layout': !isDesktop()}" />
  </div>
</template>

<script>
import TableLoader from '@/components/global/TableLoader'
import ApiServices from '@/services/api/serviceStatus'

export default {
  name: 'BeneficiaryBankStatus',
  components: { TableLoader },
  data () {
    return {
      beneBanks: {},
      limit: 3
    }
  },
  created () {
    this.populateData()
  },
  methods: {
    toggleList (pymt, type) {
      let banks = this.beneBanks[pymt]
      let list = banks[type]

      if (list.showAll) {
        list['showAll'] = false
        list['min'] = list.full.slice(0, this.limit)
      } else {
        list['showAll'] = true
        list['min'] = list.full
      }

      this.$set(this.beneBanks, pymt, banks)
    },
    populateData () {
      ApiServices.beneBankStatus().then(response => {
        const payments = ['IMPS', 'NEFT', 'RTGS', 'UPI']
        const data = response.data
        const banksDown = data.banks_down
        const banksTimeout = data.banks_timeout

        const construct = (bank, pymt) => {
          let list = bank[pymt] || []
          list = list.map(e => {
            const prefix = e.ifsc_prefix ? `(${e.ifsc_prefix})` : ''
            return {
              ...e,
              text: `${e.bank_name} ${prefix}`
            }
          })

          return {
            full: list,
            min: list.slice(0, this.limit),
            showAll: false,
            aboveLimit: list.length > this.limit,
            noData: list.length === 0
          }
        }

        for (const pymt of payments) {
          const banks = {
            downs: construct(banksDown, pymt),
            timeouts: construct(banksTimeout, pymt)
          }

          this.$set(this.beneBanks, pymt, banks)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/mixins';

  .section {
    border-radius: 5px;
    border: 2px solid $grey-outline;
    overflow: auto;

    .list {
      @include custom-grid-col(20% 40% 40%);

      &:not(:last-child) {
        border-bottom: 2px solid $grey-outline;
      }

      .head {
        @include custom-flex();
        font-weight: 600;
        background: $primary-light;
        padding: 10px;
        border-right: 2px solid $grey-outline;

        &:nth-child(3) {
          border-right: 0;
        }
      }

      .content {
        text-align: left;
        padding: 5px 30px;

        &:nth-child(2) {
          border-right: 2px solid $grey-outline;
        }

        .bank {
          padding: 2px 0;

          &::before {
            content: '';
            display: inline-block;
            height: 5px;
            width: 5px;
            background: $primary;
            border-radius: 50%;
            margin: 2px 4px 2px 0;
          }
        }

        u {
          color: $primary;
          cursor: pointer;
          margin-left: 12px;
        }
      }
    }
  }

  .mobile {
    .section {
      .list {
        .content {
          padding: 5px 10px !important;

          u {
            white-space: nowrap;
            margin-left: 0 !important;
          }
        }
      }
    }
  }
</style>
